type ResolvedTabState = {
  activeTab: string;
  shouldSyncUrlTab: boolean;
};

export const TabId = {
  reading: "reading",
  anchoring: "anchoring",
  workflow: "workflow",
  metadata: "metadata",
  summary: "ai-summary",
} as const;

export const resolveTabState = ({
  tabFromUrl,
  visibleTabIdsInDisplayOrder,
}: {
  tabFromUrl: string | null;
  visibleTabIdsInDisplayOrder: string[];
}): ResolvedTabState => {
  const visibleTabIds = new Set(visibleTabIdsInDisplayOrder);
  const defaultTab = visibleTabIdsInDisplayOrder[0] ?? TabId.metadata;

  const activeTab =
    tabFromUrl && visibleTabIds.has(tabFromUrl) ? tabFromUrl : defaultTab;

  return { activeTab, shouldSyncUrlTab: tabFromUrl !== activeTab };
};
